/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TwoFactorAuthAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import ButtonMenuIcon from 'DesignSystem/ButtonMenuIcon/index'
import React from 'react'
import SecureIcon from 'DesignSystem/Svgs/SecureIcon/index'



/** @type {import('Simple/types.js').View} */
export default function TwoFactorAuthAction({
  children,
  viewPath = "/App/Account/Content/Profile/Menu/TwoFactorAuthAction",
  isSelected
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<ButtonMenuIcon
  viewPath={`${viewPath}/ButtonMenuIcon`}
 marginRight={0}
 text="Two factor authentication"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../Content/TwoFactorAuth'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../Content/TwoFactorAuth'))}
>
{childProps => (
<SecureIcon
{...childProps}
  viewPath={`${viewPath}/SecureIcon`}
 width={16}
 height={16}
 stroke={childProps.isSelected ? "rgb(0,150,89)" : "#474747"}
/>
)}
</ButtonMenuIcon>
{children}
</React.Fragment>)
}